// البيانات التجريبية (المواصفات 32).
const sampleAr = {
  "sample.order_banner": "هذا طلب تجريبي. تنفيذه أو استرداده أو إلغاؤه لا يرسل إشعاراً لأحد ولا يُحتسب مبيعات.",
  "sample.badge": "تجريبي",
  "sample.banner_title": "أنت تشاهد بيانات تجريبية",
  "sample.banner_body": "{products} منتجاً و{orders} طلباً و{customers} عميلاً لتريك كيف سيعمل متجرك. لا ترسل أي بريد ولا تصل إلى التطبيقات ولا تُحتسب مبيعات. احذفها متى كنت جاهزاً.",
  "sample.seeding": "نضيف منتجات وعملاء وطلبات تجريبية إلى متجرك… يستغرق ذلك نحو دقيقة.",
  "sample.removing": "جارٍ حذف البيانات التجريبية…",
  "sample.failed": "تعذّرت إضافة البيانات التجريبية. لم يبقَ شيء منها؛ حاول مجدداً من الرئيسية.",
  "sample.remove_failed": "لم يكتمل حذف البيانات التجريبية. حاول مجدداً.",
  "sample.remove": "حذف البيانات التجريبية",
  "sample.remove_title": "حذف البيانات التجريبية؟",
  "sample.remove_body": "تُحذف المنتجات والمجموعات والعملاء والطلبات والخصومات والصفحات والمقالات التجريبية، وتُزال روابط القوائم إليها. تبقى منتجاتك وإعداداتك.",
  "sample.keep_edited": "الاحتفاظ بالعناصر التي عدّلتها",
  "sample.kind.product": "منتجات",
  "sample.kind.collection": "مجموعات",
  "sample.kind.page": "صفحات",
  "sample.kind.article": "مقالات",
  "sample.kind.discount": "خصومات",
  "sample.kind.blog": "مدونات",
  "sample.show_in_reports": "إظهار البيانات التجريبية في التقارير",
  "sample.show_in_reports_hint": "عند الإيقاف: تحتسب التحليلات والتقارير طلباتك الحقيقية فقط.",
  "sample.reports_on": "أصبحت التقارير تشمل الطلبات التجريبية.",
  "sample.reports_off": "أصبحت التقارير تستبعد الطلبات التجريبية.",
  "sample.hidden_in_reports": "الطلبات التجريبية مستبعدة من هذه التقارير.",
  "sample.shown_in_reports": "هذه التقارير تشمل الطلبات التجريبية.",
  "sample.explore_title": "استكشف ببيانات تجريبية",
  "sample.explore_body": "شاهد متجراً يعمل فوراً: منتجات بصور وخيارات، ومجموعات، وعملاء، وطلبات شهرين، وخصومات، وصفحات، ومدونة.",
  "sample.explore_note": "البيانات التجريبية لا ترسل بريداً لأحد وتُحذف بنقرة واحدة.",
  "sample.add": "إضافة بيانات تجريبية",
  "sample.industry": "ماذا ستبيع؟",
  "sample.industry.fashion": "أزياء",
  "sample.industry.electronics": "إلكترونيات",
  "sample.industry.grocery": "بقالة وأغذية",
  "sample.industry.beauty": "تجميل وعطور",
  "sample.wizard_title": "ابدأ بمنتجات تجريبية",
  "sample.wizard_hint": "املأ متجرك بمنتجات وعملاء وطلبات لتستكشفه، واحذفها بنقرة واحدة عند إضافة منتجاتك.",
  "home.guide.remove_sample_data": "حذف البيانات التجريبية",
};

export default sampleAr;
